import EnergieLogo from "@assets/images/logos/ila26-enerigie.svg";
import FoodWldLogo from "@assets/images/logos/ila26-agri-food.svg";
import RealEstateLogo from "@assets/images/logos/ila26-real-estate.svg";
import HealthCareLogo from "@assets/images/logos/ila26-health-care.svg";
import AutoWldLogo from "@assets/images/logos/ila26-auto-wld.svg";

import { getEnvironmentMode } from "@/utils/env";

const logos = {
  energie: EnergieLogo,
  "food-wld": FoodWldLogo,
  property: RealEstateLogo,
  "hcare-wld": HealthCareLogo,
  "auto-wld" : AutoWldLogo
};

export const getLogo = () => {
  const mode = getEnvironmentMode();
  return logos[mode] ?? EnergieLogo;
};
